













  export default {
    name: 'OneAvailableNotificationUpdate',
  }
